export const gtmId = {
  gtmId: 'GTM-PG8JLHP',
  auth: '6sBOnZx1hqPcO01xPOytLK',
  preview: 'env-2',
};